/* Pfotenmarkt Header v1 — Vanilla JS, keine Abhängigkeiten */
(function () {
  'use strict';

  if (window.PfotenmarktHeaderV1) {
    window.PfotenmarktHeaderV1.initAll(document);
    return;
  }

  var cartRefreshTimer = null;

  function refreshCartBadges(delay) {
    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(function () {
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-pm-cart-count]').forEach(function (badge) {
            badge.textContent = cart.item_count;
            badge.classList.toggle('pm-cart__badge--empty', cart.item_count === 0);
          });
          document.querySelectorAll('[data-pm-cart]').forEach(function (link) {
            link.setAttribute('aria-label', 'Warenkorb, ' + cart.item_count + ' Artikel');
          });
        })
        .catch(function () { /* Die reguläre Warenkorb-Navigation bleibt als Fallback erhalten. */ });
    }, delay || 0);
  }

  function scheduleCartRefresh() {
    refreshCartBadges(250);
    window.setTimeout(function () { refreshCartBadges(0); }, 1000);
  }

  function initHeader(header) {
    if (!header || header.dataset.pmInit) return;
    header.dataset.pmInit = '1';

    var root = header.closest('.pm-header-section') || header.parentElement || document;
    var cleanup = [];
    var searchFocused = false;
    var updateScrolledState = null;

    /* Sticky-Shrink */
    if (header.classList.contains('pm-header--sticky')) {
      updateScrolledState = function () {
        header.classList.toggle('pm-scrolled', window.scrollY > 46 && !searchFocused);
      };
      window.addEventListener('scroll', updateScrolledState, { passive: true });
      cleanup.push(function () { window.removeEventListener('scroll', updateScrolledState); });
      updateScrolledState();
    }

    /* Desktop-Dropdown: Maus, Klick/Touch, Tastatur, Escape */
    root.querySelectorAll('[data-pm-dd]').forEach(function (dd) {
      var btn = dd.querySelector('[data-pm-dd-btn]');
      var panel = dd.querySelector('[data-pm-dd-panel]');
      if (!btn || !panel) return;
      var ddLabel = btn.getAttribute('data-pm-dd-label') || '';
      var setOpen = function (open) {
        dd.classList.toggle('pm-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.setAttribute('aria-label', 'Untermenü ' + ddLabel + (open ? ' schließen' : ' öffnen'));
      };
      dd.addEventListener('mouseenter', function () { setOpen(true); });
      dd.addEventListener('mouseleave', function () { setOpen(false); });
      btn.addEventListener('click', function () { setOpen(!dd.classList.contains('pm-open')); });
      dd.addEventListener('focusout', function (event) {
        if (!dd.contains(event.relatedTarget)) setOpen(false);
      });
      dd.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          setOpen(false);
          btn.focus();
        }
      });
    });

    var onDocumentClick = function (event) {
      root.querySelectorAll('[data-pm-dd].pm-open').forEach(function (dd) {
        if (dd.contains(event.target)) return;
        dd.classList.remove('pm-open');
        var btn = dd.querySelector('[data-pm-dd-btn]');
        if (!btn) return;
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Untermenü ' + (btn.getAttribute('data-pm-dd-label') || '') + ' öffnen');
      });
    };
    document.addEventListener('click', onDocumentClick);
    cleanup.push(function () { document.removeEventListener('click', onDocumentClick); });

    /* Legacy fallback for older header markup. The current search is always
       visible and works without JavaScript, so this only runs when a toggle
       is actually present. */
    var search = root.querySelector('[data-pm-search]');
    if (search) {
      var searchToggle = search.querySelector('[data-pm-search-toggle]');
      var searchInput = search.querySelector('[data-pm-search-input]');
      var onSearchFocusIn = function () {
        searchFocused = true;
        if (updateScrolledState) updateScrolledState();
      };
      var onSearchFocusOut = function () {
        searchFocused = false;
        if (updateScrolledState) window.requestAnimationFrame(updateScrolledState);
      };
      search.addEventListener('focusin', onSearchFocusIn);
      search.addEventListener('focusout', onSearchFocusOut);
      cleanup.push(function () {
        search.removeEventListener('focusin', onSearchFocusIn);
        search.removeEventListener('focusout', onSearchFocusOut);
      });
      if (searchToggle && searchInput) {
        var setSearchOpen = function (open, focusInput) {
          search.classList.toggle('pm-open', open);
          searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          searchToggle.setAttribute('aria-label', open ? 'Suche schließen' : 'Suche öffnen');
          searchInput.disabled = !open;
          searchInput.tabIndex = open ? 0 : -1;
          searchInput.setAttribute('aria-hidden', open ? 'false' : 'true');
          if (open && focusInput) searchInput.focus();
        };
        setSearchOpen(false, false);
        searchToggle.addEventListener('click', function () {
          var willOpen = !search.classList.contains('pm-open');
          if (!willOpen && searchInput.value.trim()) {
            if (search.requestSubmit) search.requestSubmit();
            else search.submit();
            return;
          }
          setSearchOpen(willOpen, willOpen);
        });
        search.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            setSearchOpen(false, false);
            searchToggle.focus();
          }
        });
      }
    }

    /* Drawer: Scroll-Lock, Fokus-Rückgabe, Escape und Fokus-Falle. */
    var drawer = root.querySelector('[data-pm-drawer]');
    var overlay = root.querySelector('[data-pm-drawer-overlay]');
    var openBtn = root.querySelector('[data-pm-drawer-open]');
    var hideTimer = null;
    var lastFocus = null;

    function focusableDrawerItems() {
      if (!drawer) return [];
      return Array.prototype.filter.call(
        drawer.querySelectorAll('button, a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (element) {
          return !element.hidden && !element.closest('[hidden]') && element.getClientRects().length > 0;
        }
      );
    }

    function setDrawer(open, options) {
      options = options || {};
      if (!drawer || !overlay || !openBtn) return;
      window.clearTimeout(hideTimer);
      if (open) {
        lastFocus = document.activeElement;
        drawer.hidden = false;
        drawer.inert = false;
        drawer.setAttribute('aria-hidden', 'false');
        overlay.hidden = false;
        window.requestAnimationFrame(function () {
          drawer.classList.add('pm-open');
          overlay.classList.add('pm-open');
        });
        document.documentElement.classList.add('pm-scroll-lock');
        openBtn.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(function () {
          var items = focusableDrawerItems();
          if (items[0]) items[0].focus();
        });
      } else {
        drawer.classList.remove('pm-open');
        overlay.classList.remove('pm-open');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.inert = true;
        document.documentElement.classList.remove('pm-scroll-lock');
        openBtn.setAttribute('aria-expanded', 'false');
        var finish = function () {
          drawer.hidden = true;
          overlay.hidden = true;
        };
        if (options.immediate) finish();
        else hideTimer = window.setTimeout(finish, 300);
        if (options.restoreFocus !== false && lastFocus && document.contains(lastFocus)) lastFocus.focus();
        lastFocus = null;
      }
    }

    if (drawer && overlay && openBtn) {
      openBtn.addEventListener('click', function () { setDrawer(true); });
      overlay.addEventListener('click', function () { setDrawer(false); });
      var closeBtn = drawer.querySelector('[data-pm-drawer-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
      drawer.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          setDrawer(false);
          return;
        }
        if (event.key !== 'Tab') return;
        var items = focusableDrawerItems();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      drawer.querySelectorAll('[data-pm-sub]').forEach(function (sub) {
        var btn = sub.querySelector('[data-pm-sub-btn]');
        var panel = sub.querySelector('[data-pm-sub-panel]');
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var willOpen = !sub.classList.contains('pm-open');
          sub.classList.toggle('pm-open', willOpen);
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          panel.hidden = !willOpen;
          panel.inert = !willOpen;
          panel.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
        });
      });

      var desktopQuery = window.matchMedia('(min-width: 990px)');
      var onViewportChange = function (event) {
        if (event.matches) setDrawer(false, { immediate: true, restoreFocus: false });
      };
      if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onViewportChange);
      else desktopQuery.addListener(onViewportChange);
      cleanup.push(function () {
        if (desktopQuery.removeEventListener) desktopQuery.removeEventListener('change', onViewportChange);
        else desktopQuery.removeListener(onViewportChange);
        window.clearTimeout(hideTimer);
        document.documentElement.classList.remove('pm-scroll-lock');
      });
    }

    header.pmCleanup = function () {
      cleanup.forEach(function (fn) { fn(); });
      delete header.dataset.pmInit;
    };
  }

  function initAll(scope) {
    scope = scope || document;
    if (scope.matches && scope.matches('[data-pm-header]')) initHeader(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-pm-header]').forEach(initHeader);
  }

  function cleanupAll(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-pm-header]').forEach(function (header) {
      if (header.pmCleanup) header.pmCleanup();
    });
  }

  ['pm:cart:refresh', 'cart:updated', 'cart:change', 'cart:refresh', 'product:added', 'ajaxProduct:added']
    .forEach(function (eventName) {
      document.addEventListener(eventName, function () { refreshCartBadges(0); });
    });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action) return;
    if (/\/cart(?:\/(?:add|change|update))?(?:[?#]|$)/.test(form.action)) scheduleCartRefresh();
  }, true);

  window.PfotenmarktHeaderV1 = { initAll: initAll, refreshCart: refreshCartBadges };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { cleanupAll(event.target); });
})();
